import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'application/store';

import { ApplicationState } from './types';

export const selectApplicationState = (state: RootState): ApplicationState => state.application;

export const selectAppInitialized = createSelector(
  [selectApplicationState],
  (application) => application.appInitialized
);
